import { render, staticRenderFns } from "./listInformation.vue?vue&type=template&id=30be8472&scoped=true"
import script from "./listInformation.vue?vue&type=script&lang=js"
export * from "./listInformation.vue?vue&type=script&lang=js"
import style0 from "./listInformation.vue?vue&type=style&index=0&id=30be8472&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30be8472",
  null
  
)

export default component.exports